import { ModelFilterCategory } from '@store/zustand/model-filters';

/**
 * One entry of a category panel's value list: the stored value and the text
 * the row shows for it.
 */
export type CategoryOption = { value: string; label: string };

/**
 * One criteria of a CIA category: its configured name and the answers the
 * values panel lists for it. Assurance level, Coverage and Applicability are
 * each a list of these rather than a flat value list.
 */
export type CategoryCriteria = {
  id: string;
  name: string;
  options: CategoryOption[];
};

/**
 * The AC3.1 category order, grouped exactly as the root popover's dividers
 * group it.
 *
 * Only categories the store can hold appear. AC3.1 also places Report
 * inclusion after Applicability in the fourth group and CIS-18 reference alone
 * in a fifth; QSP-3581 and QSP-3456 add those rows once a client filter exists
 * for them, so no dead row is rendered in the meantime.
 */
export const CATEGORY_GROUPS: ModelFilterCategory[][] = [
  ['domains'],
  ['validationStatus', 'reviewStatus', 'operationalStatuses'],
  ['operatingModelStatuses', 'partners'],
  ['assurance_level', 'coverage', 'applicability'],
];

/**
 * The display name of each category, used by the root row and the category
 * panel's header. "Assurance level" follows the Figma label where AC3.1
 * writes "Assurance"; they name the same category.
 */
export const CATEGORY_LABELS: Record<ModelFilterCategory, string> = {
  domains: 'Scope',
  validationStatus: 'Validation status',
  reviewStatus: 'Review status',
  operationalStatuses: 'Operational status',
  operatingModelStatuses: 'Operating model',
  partners: 'Outsourcing partner',
  assurance_level: 'Assurance level',
  coverage: 'Coverage',
  applicability: 'Applicability',
};
